<template>
  <validation-observer
    ref="formModalObserver"
    tag="form"
    novalidate
    @submit.prevent="handleModalSubmit"
  >
    <div>
        <div class="p-2">
          <div class="bg-white border-radius--light py-2">
            <div class="col-12 mb-2 pl-4 pt-3">
              <em class="fas fa-times-square text-orange mr-1" />
              <span class="ml-2">Estudiante para Admisión a Intervención</span>
            </div>

            <div class="row p-4">
              <div class="col-sm-6">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  rules="required"
                >
                  <custom-drop-down
                    id="forAdmission"
                    v-model="model.assignmentSpecialist"
                    label="Especialista para Admisión:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    :disabled="disabledForm"
                    :error="errors[0]"
                    custom-error-msg="Favor seleccionar especialista para Admisión"
                    :options="admissionInfo.assignmentSpecialists"
                  />
                </validation-provider>
              </div>

              <div class="col-sm-6">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  rules="required"
                >
                  <custom-drop-down
                    id="forAdmissionService"
                    v-model="model.serviceSpecialist"
                    label="Especialista de Servicio:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    :disabled="disabledForm"
                    :error="errors[0]"
                    custom-error-msg="Favor seleccionar especialista de Servicio"
                    :options="admissionInfo.serviceSpecialists"
                  />
                </validation-provider>
              </div>
            </div>

            <div class="p-2 ml-4 mr-4">
              <div class="row bg-light-gray p-4">
                <div class="col-sm-2">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    rules="required"
                  >
                    <custom-date-picker
                      v-model="newAdmissionDate"
                      label="Fecha Admisión:"
                      :error="errors[0]"
                      :disabled="disabledAdmissionDate"
                      custom-error-msg="Favor seleccionar fecha de admisión"
                      :max-date="admissionInfo.admission.effectiveDateFrom"
                      class="custom-datetime-picker-container"
                    />
                  </validation-provider>
                </div>

                <div class="col-sm-2">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    rules="required"
                  >
                    <custom-date-picker
                      v-model="admissionInfo.admission.effectiveDateFrom"
                      label="Fecha Comienzo:"
                      :error="errors[0]"
                      custom-error-msg="Favor seleccionar fecha de comienzo"
                      :disabled="startDateDisabled || disabledForm"
                      :max-date="admissionInfo.maxDate"
                      :min-date="admissionInfo.minDate"
                      class="custom-datetime-picker-container"
                    />
                  </validation-provider>
                </div>
                <div class="col-sm-2 border-right mr-5" />
                <div class="col-sm-2">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    :rules="disabledAdmissionDate ? '' : 'required'"
                  >
                    <custom-time-picker
                      v-model="admission.admissionTimeStart"
                      :error="errors[0]"
                      label="Hora Desde:"
                      :disabled="
                        dateIsDisabled || disabledForm || disabledAdmissionDate
                      "
                      custom-error-msg="Favor seleccionar hora"
                      :max-date="new Date()"
                      class="custom-datetime-picker-container"
                    />
                  </validation-provider>
                </div>

                <div class="col-sm-2">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    :rules="disabledAdmissionDate ? '' : 'required'"
                  >
                    <custom-time-picker
                      v-model="admission.admissionTimeEnd"
                      :error="errors[0]"
                      label="Hora Hasta:"
                      :disabled="
                        dateIsDisabled || disabledForm || disabledAdmissionDate
                      "
                      custom-error-msg="Favor seleccionar hora"
                      :max-date="new Date()"
                      class="custom-datetime-picker-container"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>

            <div v-if="showServicePlaceSection" class="row p-4">
              <div class="col-12 mb-3">
                <em class="fas fa-info-circle text-orange mr-1" />
                <span>Lugar de Servicio donde ocurrió la Admisión</span>
              </div>

              <div class="col-12 row">
                <div class="col-sm-6 mb-4">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    rules="required"
                  >
                    <custom-drop-down
                      id="forAdmission1"
                      v-model="model.locationType"
                      label="Tipo de Lugar:"
                      fieldkey="id"
                      fieldname="name"
                      placeholder="Seleccione"
                      :disabled="disabledForm || isAdmissionDateReadOnly"
                      :error="errors[0]"
                      custom-error-msg="Favor seleccionar el tipo de lugar"
                      :options="admissionInfo.locationTypes"
                    />
                  </validation-provider>
                </div>
                <div v-if="isSchool" class="col-sm-6 mb-4">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    rules="required"
                  >
                    <custom-drop-down
                      id="forAdmission2"
                      v-model="model.district"
                      label="Distrito:"
                      fieldkey="id"
                      fieldname="name"
                      placeholder="Seleccione"
                      :disabled="disabledForm || isAdmissionDateReadOnly"
                      :error="errors[0]"
                      custom-error-msg="Favor seleccionar Distrito"
                      :options="collections.districts"
                    />
                  </validation-provider>
                </div>
                <div v-if="isOficinaProveedor" class="col-sm-6 mb-4">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    rules="required"
                  >
                    <custom-drop-down
                      id="forAdmission2"
                      v-model="model.location"
                      label="Lugar de Servicio:"
                      fieldkey="id"
                      fieldname="name"
                      placeholder="Seleccione"
                      :disabled="disabledForm || isAdmissionDateReadOnly"
                      :error="errors[0]"
                      custom-error-msg="Favor seleccionar Lugar de Servicio"
                      :options="collections.locations"
                    />
                  </validation-provider>
                </div>
                <div
                  v-if="isOficinaProveedor || isCsee || isHome"
                  class="col-sm-6 mb-4"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    rules="required"
                  >
                    <custom-drop-down
                      id="forAdmission2"
                      v-model="model.municipality"
                      label="Municipio:"
                      fieldkey="id"
                      fieldname="name"
                      placeholder="Seleccione"
                      :disabled="disabledForm || isAdmissionDateReadOnly"
                      :error="errors[0]"
                      custom-error-msg="Favor seleccionar Municipio"
                      :options="collections.municipalities"
                    />
                  </validation-provider>
                </div>
                <div v-if="isCsee" class="col-sm-6 mb-4">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    rules="required"
                  >
                    <custom-drop-down
                      id="forAdmission2"
                      v-model="model.center"
                      label="Centro:"
                      fieldkey="id"
                      fieldname="name"
                      placeholder="Seleccione"
                      :disabled="disabledForm || isAdmissionDateReadOnly"
                      :error="errors[0]"
                      custom-error-msg="Favor seleccionar Centro"
                      :options="collections.centers"
                    />
                  </validation-provider>
                </div>
                <div v-if="isSchool" class="col-sm-6">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    rules="required"
                  >
                    <custom-drop-down
                      id="forAdmission3"
                      v-model="model.region"
                      label="Región:"
                      fieldkey="id"
                      fieldname="name"
                      placeholder="Seleccione"
                      :disabled="disabledForm || isAdmissionDateReadOnly"
                      :error="errors[0]"
                      custom-error-msg="Favor seleccionar Región"
                      :options="collections.regions"
                    />
                  </validation-provider>
                </div>
                <div v-if="isSchool" class="col-sm-6">
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    rules="required"
                  >
                    <custom-drop-down
                      id="forAdmission4"
                      v-model="model.school"
                      label="Escuela:"
                      fieldkey="id"
                      fieldname="name"
                      placeholder="Seleccione"
                      :disabled="disabledForm || isAdmissionDateReadOnly"
                      :error="errors[0]"
                      custom-error-msg="Favor seleccionar Escuela"
                      :options="collections.schools"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>

            <div class="row pr-4 pb-4">
              <div class="col-sm">
                <div class="d-flex justify-content-end mt-4">
                  <action-button
                    variant="danger mr-2"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    @click="dispose"
                  />
                  <action-button
                    :disabled="!canUpdate"
                    variant="success pl-4 pr-4"
                    :text="isEditMode ? 'Actualizar' : 'Confirmar'"
                    @click="finish"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </validation-observer>
</template>

<script>
// components
import CustomDropDown from "custom-drop-down";
import ActionButton from "ActionButton";
import CustomTimePicker from "custom-time-picker";
import CustomDatePicker from "custom-date-picker";
// mixins
import alert from "utils/mixins/alert.mixin";
// services
import {
  getAdmissionInfo,
  confirmAdmission,
  updateAdmission,
  getAdmissionLocations,
  getAdmissionCenters,
  getAdmissionMunicipalities,
  getAdmissionRegions,
  getAdmissionSchools,
  getAdmissionDistricts
} from "@/modules/referral/api";
// constants
import AdmissionStatus from "@/utils/constants/pei/referral/admissionStatus";
import LocationTypes from "@/utils/constants/pei/referral/locationTypes";

// 3rd parties lib
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";

export default {
  name: "ConfirmAdmission",
  components: {
    CustomDropDown,
    CustomDatePicker,
    CustomTimePicker,
    ValidationProvider,
    ValidationObserver,
    ActionButton
  },
  props: {
    admissionId: {
      type: Number,
      default: undefined
    },
    value: {
      type: Object,
      default: () => undefined
    },
    dispose: {
      type: Function,
      default: () => undefined
    }
  },
  mixins: [alert],
  data() {
    return {
      model: {
        locationType: null,
        region: null,
        school: null,
        municipality: null,
        location: null,
        district: null,
        assignmentSpecialist: null,
        admissionSpecialist: null,
        center: null
      },
      collections: {
        regions: [],
        districts: [],
        schools: [],
        locations: [],
        municipalities: [],
        centers: []
      },
      newAdmissionDate: null,
      dateIsDisabled: false,
      startDateDisabled: true,
      admissionDateDisabled: false,
      canUpdate: true,
      disabledForm: false,
      admission: {
        admissionTimeStart: null,
        admissionTimeEnd: null
      },
      admissionInfo: {
        specialists: [],
        admission: {
          effectiveDateFrom: new Date(),
          effectiveDateTo: new Date()
        }
      }
    };
  },
  computed: {
    locationTypeSelected() {
      return this.model.locationType || {};
    },
    isSchool() {
      return this.locationTypeSelected.id === LocationTypes.Escuela;
    },
    isOficinaProveedor() {
      return this.locationTypeSelected.id === LocationTypes.OficinaProveedor;
    },
    isCsee() {
      return this.locationTypeSelected.id === LocationTypes.CSEE;
    },
    isHome() {
      return this.locationTypeSelected.id === LocationTypes.Hogar;
    },
    isEditMode() {
      return [
        AdmissionStatus.Admitido,
        AdmissionStatus.ServicioRelacionadoActivo
      ].includes(this.value.statusId);
    },
    hasAdminPermission() {
      return this.$store.getters.HasPermission(
        "provider.referral.admission.specialist.edit"
      );
    },
    isAdmisionProvider() {
      return (
        this.$store.state["userProfile"].user.companyId == this.value.companyId
      );
    },
    showServicePlaceSection() {
      let show = true;

      if (this.isAdmissionDateReadOnly && !this.model.locationType)
        show = false;

      return show;
    },
    isAdmissionDateReadOnly() {
      const admission = this.admissionInfo;
      const hasBilling = admission.hasBilling;

      const isReadOnly = !admission.isCurrentAcademicYear || hasBilling;

      return isReadOnly;
    },
    disabledAdmissionDate() {
      const disabled = this.isAdmissionDateReadOnly;

      if (disabled) {
        const admission = this.admissionInfo;
        const validationMsg = admission.admissionDateValidationMessage ?? "";

        if (admission.hasBilling && validationMsg.length > 0)
          this.ShowToast("Alerta", validationMsg, "error");
      }

      return disabled;
    },
    // JSF: If the admission is not for the current year and has override, then
    // use the override admissionId instead for filling the dropdowns.
    admissionIdForLocations() {
      let admissionId = this.value.admissionId;
      const overrideAdmissionId = this.admissionInfo
        .referralOverrideAdmissionId;

      if (!this.admissionInfo.isCurrentAcademicYear && overrideAdmissionId > 0)
        admissionId = overrideAdmissionId;

      return admissionId;
    }
  },
  methods: {
    async getAdmissionInfo() {
      const { data } = await getAdmissionInfo(this.admissionId);
      if (data.maxDate) data.maxDate = new Date(Date.parse(data.maxDate));

      if (data.minDate) data.minDate = new Date(Date.parse(data.minDate));

      if (data.admissionDate)
        data.admissionDate = new Date(Date.parse(data.admissionDate));

      this.admissionInfo = data;
    },
    setDataFromAdmissionInfo() {
      //set admission date
      this.dateIsDisabled =
        this.admissionInfo.admission.admissionDate && !this.isEditMode
          ? true
          : false;
      this.newAdmissionDate = this.admissionInfo.admission.admissionDate
        ? new Date(this.admissionInfo.admission.admissionDate)
        : null;

      if (this.admissionInfo.admission.admissionTimeStart != null) {
        this.admission.admissionTimeStart = moment()
          .set({
            hour: this.admissionInfo.admission.admissionTimeStart.value.hours,
            minute: this.admissionInfo.admission.admissionTimeStart.value
              .minutes
          })
          .format("HH:mm zz");
      }

      if (this.admissionInfo.admission.admissionTimeEnd != null) {
        this.admission.admissionTimeEnd = moment()
          .set({
            hour: this.admissionInfo.admission.admissionTimeEnd.value.hours,
            minute: this.admissionInfo.admission.admissionTimeEnd.value.minutes
          })
          .format("HH:mm zz");
      }
      //set admission specilist
      if (this.admissionInfo.admission.assignmentSpecialistId)
        this.model.assignmentSpecialist =
          this.admissionInfo.assignmentSpecialist || {};

      //set service specialist
      if (this.admissionInfo.admission.serviceSpecialistId)
        this.model.serviceSpecialist =
          this.admissionInfo.serviceSpecialist || {};

      //set location type
      this.model.locationType = this.admissionInfo.locationTypes.find(
        x => x.id === this.admissionInfo.locationTypeId
      );

      //setStartDateVisibility
      this.startDateDisabled = !this.admissionInfo.startDateVisibility;

      //Cant update StartDate if is created from referral management
      if (this.admissionInfo.isFromReferralManagement && this.isEditMode) {
        this.startDateDisabled = true;
        this.ShowToast(
          "Alerta",
          this.admissionInfo.startDateValidationMessage,
          "error",
          10000
        );
      }

      //Disable update button if has billing
      if (this.admissionInfo.hasBilling && this.isEditMode) {
        this.canUpdate = false;
        this.disabledForm = true;
        this.ShowToast(
          "Alerta",
          this.admissionInfo.hasBillingValidationMessage,
          "error",
          10000
        );
      }
    },
    async update(data) {
      await updateAdmission(data)
        .then(() => {
          this.ShowToast(
            "Proceso Exitoso",
            "La admisión ha sido actualizada exitosamente.",
            "success"
          );
        })
        .catch(() => {
          this.ShowToast(
            "Operación fallida",
            "No se pudo completar la operación.",
            "error"
          );
        });

      this.dispose();
    },
    async save(data) {
      await confirmAdmission(data)
        .then(() => {
          this.ShowToast(
            "Proceso Exitoso",
            "Datos guardados satisfactoriamente.",
            "success"
          );

          this.$emit("hideRow", this.value.admissionId);
          this.$emit("refreshReferralResult");
        })
        .catch(() => {
          this.ShowToast(
            "Operación fallida",
            "No se pudo completar la operación.",
            "error"
          );
        });

      this.dispose();
    },
    async finish() {
      const isValid = await this.$refs.formModalObserver.validate();

      if (!isValid) {
        this.ShowToast("Atención", "Información Incompleta.", "error");
        return;
      }
      const admission = this.admissionInfo.admission;
      admission.assignmentSpecialistId =
        this.model.assignmentSpecialist.id ?? null;
      admission.serviceSpecialistId = this.model.serviceSpecialist.id ?? null;

      let locationFiscalYearIdSelected = null;

      switch (this.locationTypeSelected.id) {
        case LocationTypes.Escuela:
          locationFiscalYearIdSelected = this.model.school.id;
          break;
        case LocationTypes.OficinaProveedor:
          locationFiscalYearIdSelected = this.model.location.id;
          break;
        case LocationTypes.CSEE:
          locationFiscalYearIdSelected = this.model.center.id;
          break;
        case LocationTypes.Hogar:
          locationFiscalYearIdSelected = this.model.municipality.id;
          break;
        default:
          break;
      }

      const data = {
        admissionId: admission.admissionId,
        effectiveDateFrom: new Date(admission.effectiveDateFrom),
        effectiveDateTo: new Date(admission.effectiveDateTo),
        admissionDate: new Date(this.newAdmissionDate), // se guarda la fecha seleccionada
        locationFiscalYearId: locationFiscalYearIdSelected, //Se guarda la nueva localización para la admisión A.L
        assignmentSpecialistId: admission.assignmentSpecialistId,
        serviceSpecialistId: admission.serviceSpecialistId,
        admissionTimeStart: this.admission.admissionTimeStart,
        admissionTimeEnd: this.admission.admissionTimeEnd,

        locationTypeId: this.model.locationType?.id,
        centerId: this.model.center !== null ? this.model.center.id : null,
        schoolId: this.model.school !== null ? this.model.school.id : null,
        regionId: this.model.region !== null ? this.model.region.id : null,
        locationId:
          this.model.location !== null ? this.model.location.id : null,
        municipalityId:
          this.model.municipality !== null ? this.model.municipality.id : null,
        districtId: this.model.district !== null ? this.model.district.id : null
      };

      if (this.isEditMode) {
        this.update(data);
        return;
      }

      this.save(data);
    },
    resetCollections() {
      this.collections = {
        regions: [],
        districts: [],
        schools: [],
        locations: [],
        municipalities: [],
        centers: []
      };
    },
    async getCenters() {
      const { data } = await getAdmissionCenters(
        this.admissionIdForLocations,
        this.model.municipality.id,
        this.locationTypeSelected.id
      );
      this.collections.centers = data;

      if (this.admissionInfo.centerId)
        this.model.center = data.find(
          x => x.id === this.admissionInfo.centerId
        );
    },
    async getLocations() {
      const { data } = await getAdmissionLocations(
        this.admissionIdForLocations,
        this.model.municipality.id
      );
      this.collections.locations = data;

      if (this.admissionInfo.locationId)
        this.model.location = data.find(
          x => x.id === this.admissionInfo.locationId
        );
    },
    async getMunicipalities() {
      const { data } = await getAdmissionMunicipalities(
        this.admissionIdForLocations,
        this.locationTypeSelected.id
      );
      this.collections.municipalities = data;

      if (this.admissionInfo.municipalityId)
        this.model.municipality = data.find(
          x => x.id === this.admissionInfo.municipalityId
        );
    },
    async getSchools() {
      const { data } = await getAdmissionSchools(
        this.admissionIdForLocations,
        this.model.district.id,
        this.locationTypeSelected.id
      );

      this.collections.schools = data;

      if (this.admissionInfo.schoolId)
        this.model.school = this.collections.schools.find(
          x => x.id === this.admissionInfo.schoolId
        );
    },
    async getDistricts() {
      const { data } = await getAdmissionDistricts(
        this.admissionIdForLocations,
        this.model.region.id,
        this.locationTypeSelected.id
      );
      this.collections.districts = data;

      if (this.admissionInfo.districtId)
        this.model.district = data.find(
          x => x.id === this.admissionInfo.districtId
        );
    },
    async getRegions() {
      const { data } = await getAdmissionRegions(
        this.admissionIdForLocations,
        this.locationTypeSelected.id
      );
      this.collections.regions = data;

      if (this.admissionInfo.regionId)
        this.model.region = data.find(
          x => x.id === this.admissionInfo.regionId
        );
    }
  },
  watch: {
    "model.locationType": {
      inmediate: true,
      handler: function(value) {
        if (value !== null) {
          this.resetCollections();
          switch (value.id) {
            case LocationTypes.Escuela:
              this.getRegions();
              break;
            case LocationTypes.OficinaProveedor:
              this.getMunicipalities();
              break;
            case LocationTypes.CSEE:
              this.getMunicipalities();
              break;
            case LocationTypes.Hogar:
              this.getMunicipalities();
              break;
            default:
              break;
          }
        }
      },
      deep: true
    },
    "model.region": {
      handler: function(value) {
        if (value === null) return;

        this.getDistricts();
      },
      deep: true
    },
    "model.district": {
      handler: function(value) {
        if (value === null) return;

        this.getSchools();
      },
      deep: true
    },
    "model.municipality": {
      handler: function(value) {
        if (value === null) return;
        if (this.locationTypeSelected.id === LocationTypes.CSEE)
          this.getCenters();
        else this.getLocations();
      },
      deep: true
    }
  },
  async mounted() {
    await this.getAdmissionInfo();
    this.setDataFromAdmissionInfo();
  }
};
</script>

<style scoped>
.info-panel {
  padding: 15px 10px 1px 20px;
  border: 6px solid #f2f2f2;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}
</style>
